import React from 'react';

const OnlineStatusContext = React.createContext({
    online: true,
    setOnline: () => {}
});

export default OnlineStatusContext;